import * as React from 'react';

class PrivacyPoliciesComponent extends React.Component {

  render() {

    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-8">
              <h1 className="bold-title">
                Política de Privacidad
              </h1>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-12 col-md-4">
              <p className="breadcrumb text-right">
                Inicio > Política de Privacidad
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <p>Somos THE CROWD ANGEL, la primera plataforma que permite invertir online en startups de base
                tecnológica con la rigurosidad y solidez de un Venture Capital; reinventamos la figura del Business
                Angel, y simplificamos el proceso para inversores y startups (en adelante, denominada colectiva e
                indistintamente <strong>"THE CROWD
                  ANGEL”</strong>, <strong>"nosotros"</strong>, <strong>"nuestro"</strong> o <strong>“nos”</strong>).
              </p>

              <p>Consideramos importante la privacidad de las personas, ya fueran inversores o emprendedores, como los
                visitantes de nuestro sitio web <a href="https://www.thecrowdangel.com">https://www.thecrowdangel.com/
                </a>, así como de los sitios web <a href="https://www.crowdangel.es">https://www.crowdangel.es</a>,
                &nbsp;<a href="https://www.thecrowdangel.es">https://www.thecrowdangel.es</a> y cualesquiera otros
                dominios titularidad de THE CROWD ANGEL relacionados en este sitio web, así como el blog &nbsp;
                <a href="blog.thecrowdangel.com">blog.thecrowdangel.com</a> (en adelante,
                la <strong>“Plataforma” </strong>) como de cualesquiera otros afectados que nos proporcionan información
                a través de los mismos, cuyos datos son tratados por THE CROWD ANGEL como parte de la prestación de
                servicios (en adelante y conjuntamente, <strong> “tu” </strong> o el <strong> “usuario”</strong> y de
                forma plural, <strong>“vosotros”</strong> o los <strong>“usuarios”</strong>). En este sentido, THE CROWD
                ANGEL se compromete al tratamiento de tus datos de acuerdo con la normativa de protección de datos
                personales aplicable. Concretamente, THE CROWD ANGEL cumplirá con las premisas establecidas en el
                REGLAMENTO (UE) 2016/679 DEL PARLAMENTO EUROPEO Y DEL CONSEJO de 27 de abril de 2016 relativo a la
                protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre
                circulación de estos datos y por el que se deroga la Directiva 95/46/CE (en adelante,
                el <strong>“RGPD”</strong>) y cualesquiera otras regulaciones correlativas de aplicación en vigor en
                cada momento.</p>

              <p>En base a ello, THE CROWD ANGEL informa de su Política de Privacidad, con el fin de hacer conocedores a
                los usuarios sobre el tratamiento de sus datos, así como de los principios fundamentales sobre
                protección de datos personales que aplica.</p>

              <p>A colación con lo anterior, instamos a todos los usuarios a leer con detenimiento esta Política de
                Privacidad al objeto de informarse sobre las normas y prácticas que hemos elaborado para proteger los
                datos personales y para conocer mejor nuestras relaciones con terceros que pudieran tener acceso a tales
                datos.</p>

              <p>En cualquier caso, el usuario es el único responsable de la información que proporcione en la
                Plataforma y si en un futuro THE CROWD ANGEL desease utilizarla para fines distintos de los referidos,
                le informaremos de estos nuevos fines y solicitaremos su consentimiento, si fuera preciso.</p>

              <p>El usuario garantiza que la información facilitada a THE CROWD ANGEL es veraz y actualizada y se
                compromete a comunicar cualquier cambio de circunstancias que puedan afectar a su condición. Asimismo,
                el usuario garantiza que tiene la autorización pertinente para comunicar la información de terceros y
                que ha informado a los mismos sobre el tratamiento de datos personales por parte de THE CROWD ANGEL para
                los fines relacionados con nuestros servicios.</p>

              <h3>1.- ¿Quién es el responsable del tratamiento?</h3>

              <p>Datos de contacto del responsable del tratamiento: <strong>THE CROWD ANGEL P.F.P, S.L., </strong> con 
              domicilio en Madrid (28010), calle Orfila 10, Bajos Izq, provista de N.I.F. número B-65.640.724
                y correo electrónico de contacto <a href="mailto:privacy@thecrowdangel.com">privacy@thecrowdangel.com
                </a>. Inscrita en el Registro Mercantil de Barcelona en el tomo 42798, folio 23, Hoja B413271,
                Inscripción
                1.
              </p>
              <h3>2.- ¿Cuáles son los derechos de protección de datos de los usuarios? </h3>

              <p>Los usuarios pueden solicitar los siguientes derechos:</p>

              <ul>
                <li>Derecho a solicitar el acceso a los datos personales: puedes preguntar a THE CROWD ANGEL si esta
                  compañía está tratando sus datos, y en caso afirmativo acceder a los mismos.
                </li>

                <li>Derecho a solicitar su rectificación si los datos son inexactos, o completar los datos que tengamos
                  incompletos.
                </li>

                <li>Derecho a solicitar la supresión de sus datos.</li>

                <li>Derecho a solicitar la limitación de su tratamiento: en este caso únicamente los conservaremos para
                  el ejercicio o la defensa de reclamaciones.
                </li>

                <li>Derecho a oponerse al tratamiento: THE CROWD ANGEL dejará de tratar los datos personales, con la
                  excepción que deban seguir tratándose por motivos legítimos o para el ejercicio o defensa de posibles
                  reclamaciones.
                </li>

                <li>Derecho a la portabilidad de los datos en caso de que el usuario quiera que sus datos sean tratados
                  por otro responsable del tratamiento, THE CROWD ANGEL le facilitará el trasvase de sus datos al nuevo
                  responsable.
                </li>

                <li>Derecho a no ser objeto de una decisión basada únicamente en el tratamiento automatizado de sus
                  datos personales.
                </li>
              </ul>

              <p>Si hubieses otorgado el consentimiento para alguna finalidad específica, podrás retirar el mismo cuando
                lo desees, sin que ello afecte a la licitud del tratamiento basado en el consentimiento previo a su
                retirada.</p>

              <p>En cualquier caso, en el momento en que el usuario ejerza sus derechos de supresión, todos los datos
                personales vinculados a su cuenta, así como la información y contenidos que se integren en su perfil
                serán cancelados. Asimismo, en caso de que el usuario ejerza el derecho de supresión sobre los datos
                necesarios para que THE CROWD ANGEL pueda prestar los servicios de la Plataforma, THE CROWD ANGEL se
                verá obligado a dar por finalizada su relación con el usuario, procediendo a darle de baja, sin derecho
                a reclamación alguna por parte de éste. </p>

              <p>Para ejercitar sus derechos, los usuarios deberán enviar una comunicación por escrito al domicilio
                social de THE CROWD ANGEL o a la dirección de correo electrónico indicada en el apartado 1 de esta
                Política de Privacidad, incluyendo en ambos casos fotocopia de su DNI u otro documento de identificativo
                equivalente. </p>

              <h3>3.- ¿Cómo puedes presentar una reclamación en la Agencia Española de Protección de Datos?</h3>

              <p><span style={{textDecoration: 'underline'}}>Puedes utilizar los modelos y formularios sobre los
                derechos referidos en el punto anterior</span> dirigiéndote a la página oficial de la Agencia Española
                de Protección de Datos. </p>

              <p><span style={{textDecoration: 'underline'}}>Reclamación ante la Autoridad de Control:</span> Si
                consideras que THE CROWD ANGEL está tratando tus datos personales de forma inapropiada, puedes dirigir
                tus reclamaciones a THE CROWD ANGEL o a la Autoridad de Control correspondiente. En España debe
                dirigirse ante la Agencia Española de Protección de Datos. </p>

              <h3>4.- ¿En qué casos recabamos tus datos personales y de qué tipo son?</h3>

              <p>En base a la presente Política de Privacidad, se considera "dato personal”: cualquier información que
                te identifique o pueda utilizarse para identificarte, como por ejemplo tu nombre, dirección, número de
                teléfono o dirección de correo electrónico. </p>

              <p>Si decides proporcionarnos tus datos personales, THE CROWD ANGEL podrá disponer de los siguientes: </p>

              <h4>a) Datos personales facilitados voluntariamente por el usuario:</h4>

              <h5>a.1) Inversor:</h5>
              <ul>
                <li>Apertura de cuenta como inversor:</li>
                <ul>
                  <li>Nombre.</li>
                  <li>Apellido.</li>
                  <li>Email.</li>
                </ul>
              </ul>

              <ul>
                <li>Confirmar el registro y perfilar la cuenta de inversor:</li>
                <ul>
                  <li>Nombre.</li>
                  <li>Apellidos.</li>
                  <li>Email.</li>
                  <li>Teléfono.</li>
                  <li>NIF/NIE/Nº Pasaporte.</li>
                  <li>Fotografía.</li>
                  <li>Sectores de interés.</li>
                  <li>Vinculación a redes sociales (p. ej. Linkedin).</li>
                  <li>Presentación personal.</li>
                  <li>Datos relacionados con el objetivo de la inversión.</li>
                  <li>Otros datos de interés.</li>
                  <li>Datos del cónyuge: Nombre y apellido, DNI, Fecha de nacimiento, dirección y email.</li>
                </ul>
              </ul>

              <h5>a.2.) Información de contacto del emprendedor al incorporar una operación:</h5>

              <ul>
                <li>Nombre.</li>
                <li>Apellidos.</li>
                <li>Email.</li>
                <li>Dirección Postal
                  <li>Fecha de nacimiento. </li>
                  <li>Estado civil, en el caso de que esté casado en régimen de bienes gananciales.</li>
                  <li>Nacionalidad</li>
                  <li>Otros datos de interés.</li>
                </li>
              </ul>

              <p>Sin perjuicio de lo establecido en el apartado 5 de esta Política de Privacidad, estos datos personales
                son tratados cuando interactúes con THE CROWD ANGEL y nuestros representantes; cuando participes o
                solicites que se te considere para participar en actividades relacionadas con THE CROWD ANGEL, como
                prestaciones de servicios o encuestas online sobre nuestros servicios o actividades; cuando interactúas
                con la Plataforma al solicitarte que proporciones datos personales, tal y como se describe en esta&nbsp;
                <a href="#p_privacy">Política de Privacidad</a> y&nbsp;
                <a href="https://www.thecrowdangel.com/politica-de-cookies">Política de Cookies</a>; al inscribirse en
                nuestra Plataforma o utilizar ciertas funcionalidades sin inscribirse, como participar en nuestros
                servicios interactivos. </p>

              <h4>b) Datos personales que nuestro sitio web obtiene de tu ordenador o dispositivo electrónico:</h4>

              <ul>
                <li>Cookies, para <a href="https://www.thecrowdangel.com/">https://www.thecrowdangel.com/</a>, así como
                  de los sitios web <a href="https://www.thecrowdangel.com/">https://www.crowdangel.es</a>,&nbsp;
                  <a href="https://www.thecrowdangel.com/">https://www.thecrowdangel.es</a> y cualesquiera otros
                  dominios titularidad de THE CROWD ANGEL relacionados en este sitio web.
                </li>

                <li>IP.</li>

              </ul>

              <p>Si deseas más información sobre el uso de cookies por parte de THE CROWD ANGEL, consulta nuestra &nbsp;
                <a href="https://www.thecrowdangel.com/politica-de-cookies">Política de Cookies</a>;.</p>

              <h3 id="como-usamos-los-datos">5. ¿Cómo usamos los datos personales de usuarios?</h3>

              <p>THE CROWD ANGEL comunica a los usuarios a los que aplique, que los datos personales que nos faciliten y
                captemos serán identificados en el Registro de Actividades de Tratamiento titularidad de THE CROWD
                ANGEL, siendo empleados con el propósito de:</p>

              <ul>
                <li>Dar de alta a un usuario, generando una cuenta al registrarse como inversor o emprendedor en THE
                  CROWD ANGEL.
                </li>

                <li>Prestar nuestros servicios, de acuerdo los&nbsp;
                  <a href="https://www.thecrowdangel.com/terminos-y-condiciones">Términos y Condiciones</a> y/o contrato
                  que se establezcan entre THE CROWD ANGEL y cada uno de los usuarios.
                </li>

                <li>Permitir el acceso a las opciones que requieran de registro (ej. envío de CV o solicitud de empleo,
                  opcionalidades en perfil de cuenta, activación de alertas personalizadas).
                </li>

                <li>Responder a las consultas o solicitudes de información que puedan realizar los usuarios.</li>

                <li>En el caso de que el usuario haya marcado la correspondiente casilla a tales efectos, mantenerte
                  informado a través del envío de notificaciones por email y / u otros medios electrónicos, el contenido
                  de las cuales versará principalmente sobre los servicios y productos de nuestros partners, relativas a
                  los sectores náutico, automovilístico, textil y del calzado, editorial, de banca y finanzas, de
                  alquiler de vehículos, hostelero, turístico y relacionado con los viajes de placer (contratación de
                  viajes y packs turísticos), cosmético e higiene personal, alimentación, comercio de bienes de consumo,
                  tecnológico (empresas centradas en la creación de aplicaciones para smartphones destinadas a
                  consumidores) y Organizaciones No Gubernamentales. El contenido de las citadas notificaciones será
                  seleccionado en cada momento por THE CROWD ANGEL y remitidos a ti directamente por nosotros.
                </li>

                <li>En el caso de que el usuario haya marcado las correspondientes casillas a tales efectos, remitirle
                  notificaciones push relativas a nuestros servicios y productos.
                </li>
              </ul>

              <h3>6.- ¿Por qué tratamos tus datos personales?</h3>

              <p>THE CROWD ANGEL puede tratar sus datos personales basándose en cualquiera de las siguientes bases
                legales:</p>
              <li>(A)&nbsp;
                <a
                  href="/public/fines_comerciales.pdf"
                  target="_blank"
                >
                  fines comerciales
                  legítimos;
                </a>
              </li>
              <li>(B)&nbsp;
                <a
                  href="/public/fines_comerciales.pdf"
                  target="_blank"
                >
                  según sea necesario
                  para el cumplimiento de un contrato del cual usted sea parte;
                </a>
              </li>
              <li>(C)&nbsp;
                <a
                  href="/public/fines_comerciales.pdf"
                  target="_blank"
                >
                  cuando sea necesario para cumplir con las obligaciones legales y reglamentarias que deba aplicar
                  THE CROWD ANGEL;
                </a>
              </li>
              <li>(D) cuando haya dado su consentimiento.
              </li>

              <h3>7. ¿Quién podrá acceder a tus datos personales?</h3>

              <p>Dependiendo de los fines para los que se recopilan los datos personales, pueden acceder a dicha
                información, indistintamente, las siguientes personas: </p>

              <ul>
                <li>Personal autorizado de THE CROWD ANGEL o sus representantes actuando en nombre de THE CROWD ANGEL,
                  sujetos a las leyes de protección de datos personales que resulten de aplicación;
                </li>

                <li>Autoridades reguladoras u otros terceros de conformidad con las leyes aplicables;</li>

                <li>Terceros proveedores de servicios que procesan información como un encargado de tratamiento de datos
                  personales, bajo las instrucciones de THE CROWD ANGEL (por ejemplo, [determinar ejemplo de tercero
                  proveedor de servicios]). Todo ello solo después de llevar a cabo las medidas necesarias para asegurar
                  que podemos compartir dicha información en cumplimiento de las leyes de protección de datos
                  aplicables.
                </li>
              </ul>

              <p>En ocasiones, los datos de los emprendedores podrán ser comunicados a los inversores, en el marco de
                los servicios prestados por THE CROWD ANGEL. Y los datos de inversores podrán ser compartidos entre los
                propios inversores, si ellos así lo han aceptado.</p>

              <p>No venderemos ni divulgaremos a terceros ninguna información o dato personal que nos hayas
                proporcionado en nuestra Plataforma y pueda identificarte directa o indirectamente.</p>

              <h3>8.- Prestación de servicios de THE CROWD ANGEL</h3>

              <p>En relación a los datos de carácter personal a los que THE CROWD ANGEL pudiera acceder en nombre de un
                tercero (responsable del tratamiento), para la prestación de los servicios hacia el mismo en la
                Plataforma, en nombre de terceros THE CROWD ANGEL, se obliga a tratarlos de acuerdo con lo establecido
                en la normativa de aplicación en vigor. En concreto a: i) Tratarlos únicamente conforme a las
                instrucciones del responsable del tratamiento; ii) No utilizarlos con finalidades diferentes a la
                prestación de los servicios; iii) No comunicarlos a terceros, ni tan siquiera para su conservación; iv)
                Implementar las medidas de seguridad exigibles conforme a la normativa sobre los sistemas y en los que
                se integran para garantizar su confidencialidad y evitar su pérdida o el acceso no autorizado.</p>

              <h3>9.- ¿Dónde se tratan tus datos personales?</h3>

              <p>THE CROWD ANGEL es una compañía nacional con sede en España. THE CROWD ANGEL no llevará a cabo
                transferencias de datos personales fuera del Espacio Económico Europeo (EEE). En el caso de que tales
                transferencias se realizarán, THE CROWD ANGEL lo haría en cumplimiento con las leyes de protección de
                datos personales aplicables. Independientemente al lugar donde se recabe o se traten tus datos
                personales, THE CROWD ANGEL vela y garantiza que los proveedores de servicio mantengan las medidas de
                seguridad administrativas, técnicas y físicas apropiadas para proteger tu información. </p>

              <h3>10.- ¿Cómo protegemos tus datos personales? </h3>

              <p>THE CROWD ANGEL ha adoptado medidas de seguridad para evitar la pérdida, uso o acceso accidental no
                autorizado de su información personal o su modificación o divulgación inadecuada. Asimismo, limitaremos
                el acceso a su información personal a quienes necesiten procesar dicha información por motivos
                comerciales, quienes sólo tratan su información personal siguiendo nuestras instrucciones y estarán
                sujetos al deber de confidencialidad.</p>

              <p>Hemos implantado procedimientos para hacer frente a cualquier posible violación de la seguridad de la
                información y le notificaremos a usted y a cualquier organismo regulador pertinente cualquier presunta
                violación, según proceda, de acuerdo con nuestras obligaciones legales. </p>

              <h3>11.- ¿Durante cuánto tiempo conservaremos tus datos personales?</h3>

              <p>THE CROWD ANGEL procesa tus datos personales durante el periodo necesario para cumplir con los fines
                establecidos en esta Política de Privacidad, así como para conservar tus datos personales en
                cumplimiento de las disposiciones de las leyes y normativas pertinentes. </p>

              <p>El criterio que seguimos para ello viene determinado por:</p>

              <ul>
                <li>La finalidad de los datos personales recopilados y el cumplimiento de dicho fin.</li>

                <li>Las razones por las cuales los datos personales se recopilan: p. ej., en caso de consentimiento,
                  usted puede revocarlo en cualquier momento.
                </li>

                <li>Periodos de almacenamiento obligados según los requisitos contractuales y normativos.</li>
              </ul>

              <p>Tenga presente que en algunos casos THE CROWD ANGEL está obligada a conservar ciertos datos personales
                tuyos. En cualquier caso, los datos desagregados serán conservados sin plazo de supresión. </p>

              <h3>12.- Confidencialidad</h3>

              <p>Los profesionales que trabajan en THE CROWD ANGEL y que tuvieran algún tipo de intervención en los
                servicios prestados al usuario, están comprometidos a no divulgar ni hacer uso de la información a la
                que hayan accedido. La información suministrada por el usuario tendrá, en todo caso, la consideración de
                confidencial, sin que pueda ser utilizada para otros fines que los relacionados con la gestión vinculada
                a la cuenta de usuario y a los servicios contratados a THE CROWD ANGEL, en su caso. En este sentido, nos
                obligamos a no divulgar ni revelar información sobre las pretensiones del usuario, la información
                solicitada o la duración de su relación con este. </p>

              <h3>13.- Redes sociales</h3>

              <p>THE CROWD ANGEL tiene presencia en algunas de las principales redes sociales de Internet, en las que
                actúa como responsable del tratamiento en relación con los datos personales publicados por THE CROWD
                ANGEL.</p>

              <p>THE CROWD ANGEL tratará los datos personales en cada red social según las normas establecidas al efecto
                por cada una de ellas. Por tanto, y mientras no se manifieste lo contrario, desde THE CROWD ANGEL
                podremos informar, a nuestros seguidores en la red social correspondiente de nuestras actividades,
                eventos, y demás temas relacionados, incluida la atención al seguidor, por los canales que la red social
                proporcione a tal efecto.</p>

              <p>THE CROWD ANGEL no extraerá datos personales de las redes sociales, salvo que el usuario nos dé su
                consentimiento expreso.</p>

              <h3>14.- Categoría especial de datos personales</h3>

              <p>No recabaremos ni procesaremos cualesquiera datos personales especialmente sensibles o incluidos en la
                categoría especial de datos personales de los usuarios, a menos que los mismos nos los hayan
                proporcionado explícitamente. Las categorías especiales de datos personales hacen referencia a
                información relacionada con raza u origen étnico, opiniones políticas, creencias religiosas o
                filosóficas u otras creencias de naturaleza similar, afiliación a sindicatos, datos genéticos, datos
                biométricos para los fines exclusivos de identificación de una persona física, datos de salud, vida
                sexual u orientación sexual.</p>

              <h3>15.- Política sobre uso infantil</h3>

              <p>La Plataforma no está diseñado ni dirigido a niños menores de dieciséis (16) años, sin autorización de
                los padres o tutor legal. En este sentido, no recopilamos deliberadamente información de dichas
                personas. En cualquier caso, si los padres o representantes legales consideran que sus hijos nos han
                remitido datos personales, sin su consentimiento, comuníquese con nosotros escribiendo a &nbsp;
                <a href="mailto:privacy@thecrowdangel.com">privacy@thecrowdangel.com</a>.</p>

              <h3>16.- Marketing directo</h3>

              <p>No utilizaremos los datos personales de usuarios con fines de marketing directo sin tu expreso
                consentimiento previo, en virtud de lo definido en el <a href="#como-usamos-los-datos">apartado 5 de
                  esta Política de Privacidad</a>.
              </p>

              <p>Si en algún momento decides dejar de recibir información comercial o promocional de THE CROWD ANGEL o
                terceros, puedes, sin cargo alguno y sin tener que facilitar una justificación, darte de baja de
                campañas de marketing directo y oponerte al procesamiento futuro de tus datos personales para dichos
                fines enviándonos un correo electrónico a&nbsp;
                <a href="mailto:privacy@thecrowdangel.com">privacy@thecrowdangel.com</a>.
              </p>

              <p>Ten en cuenta que, aunque decidas no suscribirte o te des de baja de los correos electrónicos
                promocionales o newsletters puede que sigamos necesitando contactar contigo en referencia con
                información importante de índole no comercial, tal como solución de problemas, inactividad o bajo uso,
                detección y prevención de errores o en general para cumplir con el &nbsp;
                <a href="https://www.thecrowdangel.com/terminos-y-condiciones">Aviso Legal y operativa de la
                  Plataforma</a>.
              </p>

              <h3>17.- Toma automatizada de decisiones</h3>

              <p>THE CROWD ANGEL integra el contenido de las distintas webs de anuncios clasificados en nuestra
                Plataforma y dirigimos tráfico de calidad a sus anuncios. Asimismo, somos capaces de generar tráfico
                adicional promocionando el anuncio adecuado al usuario adecuado y en el momento adecuado a través de
                nuestros productos de publicidad nativa.
              </p>

              <p>En este sentido utilizamos procesos automatizados de toma de decisiones, incluida la elaboración de
                perfiles (profiling), cuando nos haya autorizado explícitamente a hacerlo. En ese caso, le informaríamos
                acerca de la lógica utilizada en la decisión, así como acerca del significado y las consecuencias
                previstas de dicho procesamiento para usted.
              </p>

              <h3>18.- Enlaces a otros sitios web, aplicaciones o plataformas</h3>

              <p>En la Plataforma hay enlaces a otros sitios web, aplicaciones o plataformas de cualquier tipo que
                consideramos potencialmente útiles e informativos para ti. No obstante, tenga presente que no avalamos
                ni recomendamos el contenido ni los servicios de los mismos, ni somos responsables de sus políticas de
                privacidad y condiciones de uso. En este sentido, te recomendamos que tengas en cuenta y leas las
                políticas de privacidad de todos los sitios que visites. Recuerda que lo que se indica en esta Política
                de Privacidad solo rige para los datos personales que recaba y/o trata THE CROWD ANGEL.</p>

              <h3>19.- Modificaciones e integridad de nuestra Política de Privacidad</h3>

              <p>Solo utilizaremos tus datos personales según lo establecido en la Política de Privacidad que esté en
                vigor en el momento en que recabemos tus datos personales. THE CROWD ANGEL se reserva el derecho a
                modificar en cualquier momento esta Política de Privacidad, publicando tale modificaciones en nuestra
                Plataforma, por lo que te recomendamos que la visites cada vez que accedas a la Plataforma. Si en algún
                momento decidimos usar datos personales de modo diferente a lo que se declaró en el momento de su
                obtención, te lo comunicaremos por correo electrónico, siempre y cuando dispongamos de la misma. En ese
                momento se le dará la opción de autorizar otros usos o divulgaciones de los datos personales que nos
                hubieras facilitado antes de la modificación de nuestra Política de Privacidad.</p>

              <p>En caso de que cualquier cláusula de la presente Política de Privacidad fuera anulada o considerada
                nula, el resto de condiciones no se verán afectadas, conservando plenamente su validez y vigencia, en
                atención a la normativa vigente de aplicación en cada momento.</p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default PrivacyPoliciesComponent;



// WEBPACK FOOTER //
// ./src/modules/privacy-and-cookies/PrivacyPolicies.component.tsx